<template>
  <svg
    width="58"
    height="58"
    viewBox="0 0 58 58"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      :class="active ? 'a-active' : 'a'"
      cx="29"
      cy="29"
      r="28.5"
      stroke="#142B6F"
    />
    <circle
      :class="active ? 'a-active' : 'a'"
      cx="28.9997"
      cy="28.9997"
      r="7.13158"
      stroke="#142B6F"
    />
    <circle
      :class="active ? 'a-active' : 'a'"
      cx="28.9995"
      cy="29"
      r="14.7632"
      stroke="#142B6F"
    />
    <circle
      :class="active ? 'a-active' : 'a'"
      class="a-fill"
      cx="17"
      cy="38"
      r="2"
    />
    <circle
      :class="active ? 'a-active' : 'a'"
      class="a-fill"
      cx="39"
      cy="18"
      r="2"
    />
  </svg>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.a {
  stroke: #CDD1DE;
  stroke-width: 1px;
}

.a-active {
  &.a-fill {
      fill: #142B6F;
  }
}
</style>
